'use client';
import { usePaymentReview } from '~/store/wmap-store';
import PaymentError from '~/components/payment-error';
import SynchronyError from '~/components/payment-error/synchrony-error';
import {
  Maybe,
  UsAePayErrorMessage,
  SynchronyErrorMessage,
  ProgressiveConfiguration,
} from '~/gql/__generated__/types';

interface PaymentErrorWrapperProps {
  error?: string;
  synchronyError: SynchronyErrorMessage | null;
  storePhone: string;
  usaEPayErrorMessages?: Maybe<Maybe<UsAePayErrorMessage>[]> | undefined;
  progressiveConfigs?: ProgressiveConfiguration;
}

const PaymentErrorWrapper: React.FC<PaymentErrorWrapperProps> = ({
  error,
  synchronyError,
  storePhone,
  usaEPayErrorMessages,
  progressiveConfigs,
}) => {
  const paymentReview = usePaymentReview();

  // Hide SYF (Synchrony) errors when user is in Progressive review mode
  if (paymentReview.review && synchronyError) {
    return null;
  }

  if (synchronyError) {
    return (
      <SynchronyError
        errorConfig={synchronyError}
        progressiveConfigs={progressiveConfigs}
      />
    );
  }

  if (error) {
    return (
      <PaymentError
        errCode={error}
        storePhone={storePhone}
        usaEPayErrorMessages={usaEPayErrorMessages}
      />
    );
  }

  return null;
};

export default PaymentErrorWrapper;
